export const OPTION_TYPES = {
  SKIP: 'skip',
  INCLUDED: 'included',
  PRICE: 'price',
};
